import typeCheck from 'common/util/typeCheck';
import { SR_API_ACTION_UTILITY_PROFIT_TIPS_GET_LIST } from 'api/utilityActionTypes';

export default async function getList({ state, apiClient }) {
  const path = ['utilityProfitTips'];
  if (state.get(path)) {
    return;
  }
  return apiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PROFIT_TIPS_GET_LIST,
    state: state,
    onSuccess(utilityProfitTips) {
      typeCheck('utilityProfitTips::Array', utilityProfitTips);
      state.set(path, utilityProfitTips);
      return utilityProfitTips;
    },
  });
}
